import { render, staticRenderFns } from "./ManualPermalinkDialog.vue?vue&type=template&id=7d98cccc&"
import script from "./ManualPermalinkDialog.vue?vue&type=script&lang=js&"
export * from "./ManualPermalinkDialog.vue?vue&type=script&lang=js&"
import style0 from "./ManualPermalinkDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports